<template>
  <footer class="w-full bg-white">
    <div class="text-center text-xl py-1 bg-[#002D74] text-white">
      L'ABUS D'ALCOOL EST DANGEREUX POUR LA SANTÉ, À CONSOMMER AVEC MODÉRATION.
    </div>
    <ul
      class="flex flex-wrap lg:flex-nowrap justify-center items-center gap-2 py-4"
    >
      <li><a href="https://oxoformdocs.fra1.digitaloceanspaces.com/680a4ee057000c7ade0696ef/reglement.pdf" target="_blank">Règlement</a></li>
      <li>|</li>
      <li><router-link to="/mentions">Mentions légales</router-link></li>
      <li>|</li>
      <li><a href="https://oxoformdocs.fra1.digitaloceanspaces.com/680a4ee057000c7ade0696ef/politique.pdf" target="_blank">Politique de confidentialité</a></li>
      <li>|</li>
      <li><router-link to="/contact">Nous contacter</router-link></li>
    </ul>
  </footer>
</template>

<script>
export default {
  name: "footer-view",
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>
